import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const ContactUs: React.FC = () => (
  <footer className="bg-gray-900 text-gray-300">
    <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Quizora Info */}
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-white">Quizora</h3>
          <p className="text-gray-400">
            Test your aptitude skills and win exciting prizes in our monthly contests.
          </p>
        </div>

        {/* Quick Links */}
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-white">Quick Links</h3>
          <ul className="space-y-2">
            <li><a href="/" className="text-gray-400 hover:text-white transition">Home</a></li>
            <li><a href="/how-it-works" className="text-gray-400 hover:text-white transition">How It Works</a></li>
            <li><a href="/rewards" className="text-gray-400 hover:text-white transition">Rewards</a></li>
            <li><a href="/leaderboard" className="text-gray-400 hover:text-white transition">Leaderboard</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-white">Contact Us</h3>
          <div className="space-y-2 text-gray-400">
            <p className="flex items-start">
              <span className="mr-2 mt-1">✉️</span>
              support@quizora.com
            </p>
            <p className="flex items-start">
              <span className="mr-2 mt-1">📞</span>
              +91 XXXXXXXXX
            </p>
            <p className="flex items-start">
              <span className="mr-2 mt-1">📍</span>
              <span>
                123 Tech Park,<br />
                Bangalore,<br />
                Karnataka, India
              </span>
            </p>
          </div>
        </div>

        {/* Social Media */}
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-white">Follow Us</h3>
          <div className="flex space-x-4">
            <a href="#" className="bg-gray-800 hover:bg-indigo-600 rounded-full p-3 transition">
              <FaFacebookF className="w-5 h-5" />
            </a>
            <a href="#" className="bg-gray-800 hover:bg-blue-400 rounded-full p-3 transition">
              <FaTwitter className="w-5 h-5" />
            </a>
            <a href="#" className="bg-gray-800 hover:bg-blue-600 rounded-full p-3 transition">
              <FaLinkedinIn className="w-5 h-5" />
            </a>
            <a href="#" className="bg-gray-800 hover:bg-pink-600 rounded-full p-3 transition">
              <FaInstagram className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>

      {/* Divider */}
      <hr className="border-gray-800 my-8" />

      {/* Bottom Footer */}
      <div className="flex flex-col md:flex-row justify-between items-center pt-4">
        <span className="text-gray-500 text-sm mb-4 md:mb-0">
          © 2023 Quizora. All rights reserved.
        </span>
        <div className="flex space-x-4 text-sm">
          <a href="#" className="text-gray-500 hover:text-white transition">Privacy Policy</a>
          <span className="text-gray-500">|</span>
          <a href="#" className="text-gray-500 hover:text-white transition">Terms of Service</a>
          <span className="text-gray-500">|</span>
          <a href="#" className="text-gray-500 hover:text-white transition">Refund Policy</a>
        </div>
      </div>
    </div>
  </footer>
);

export default ContactUs;